<template>
  <div style="margin-left: 40px; margin-right: 40px;">
    <el-row>
      <el-col :span="24">
        <div class="demo-block demo-box " >
          <el-form class="formdiv" ref="form"  label-width="100px">
            <el-form-item label="网站标题">
              <el-input v-model="sitetitle"></el-input>
              <span class="txtdes">网站标题会显示在浏览器的顶部，建议填写您网站的名称。</span>
            </el-form-item>
            <el-form-item label="欢迎语">
              <el-input v-model="sitewelcome"></el-input>
              <span class="txtdes">网站顶部显示的网站欢迎语。</span>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="sitekey"></el-input>
              <el-tag>标签一</el-tag>
              <el-tag type="success">标签二</el-tag>
              <el-tag type="info">标签三</el-tag>
              <el-tag type="warning">标签四</el-tag>
              <el-tag type="danger">标签五</el-tag>
            </el-form-item>
            <el-form-item label="上传Logo" class="yyzz_upload">
              <el-upload
                class="avatar-uploader"
                drag
                action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                :data="{'bucketname':'wyzb1','bucketpath':'website'}"
                :on-success="OnWebSiteSuccess"
                :on-error="OnWebSiteError"
                :before-upload="BeforeWebSiteUpload"
                >
                <img v-if="wsimgurlok" :src="wsimgurl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="底部版权">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="sitebuttom">
              </el-input>
            </el-form-item>
            <div class="mybtncontainer">
              <el-button type="primary" @click="savesite">保存修改</el-button>
              <el-button @click="cancelsite">取消</el-button>
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import '../../../static/css/my.css'
import ElFormItem from '../../../node_modules/element-ui/packages/form/src/form-item'
var that
export default {
  components: {ElFormItem},
  name: 'SiteSet',
  data () {
    return {
      sitetitle: '',
      sitewelcome: '',
      sitekey: '',
      sitebuttom: '',
      upfilepath: '',
      wsimgurlok: false,
      wsimgurl: '',
      khid: '',
      siteid: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var qstr = 'id>0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qbi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(res.data.data)
            if (res.data.data === '[]') {
              that.siteid = -1
            } else {
              var siteinfo = JSON.parse(res.data.data)
              console.log(siteinfo)
              that.siteid = siteinfo[0].id.Int64
              that.sitetitle = siteinfo[0].title.String
              that.sitewelcome = siteinfo[0].welcome.String
              that.sitekey = siteinfo[0].sitekey.String
              that.sitebuttom = siteinfo[0].sitebuttom.String
              that.wsimgurlok = true
              that.wsimgurl = siteinfo[0].logo.String
              that.upfilepath = siteinfo[0].logo.String
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    ReSetParams: function () {
    },
    OnWebSiteError (res) {
      console.log(res)
    },
    OnWebSiteSuccess (res, file, fileList) {
      if (res.success) {
        this.wsimgurlok = true
        console.log(res.data[0].osspath)
        this.wsimgurl = res.data[0].osspath
        this.upfilepath = res.data[0].osspath
        Message.success('上传成功，已上传至OSS存储')
      }
    },
    BeforeWebSiteUpload (file) {
    },
    savesite () {
      console.log(this.sitetitle)
      console.log(this.sitewelcome)
      console.log(this.sitekey)
      console.log(this.sitebuttom)
      console.log(this.upfilepath)
      var savedata = {
        id: {Int64: parseInt(this.siteid), Valid: true},
        title: {String: this.sitetitle, Valid: true},
        welcome: {String: this.sitewelcome, Valid: true},
        sitekey: {String: this.sitekey, Valid: true},
        logo: {String: this.upfilepath, Valid: true},
        sitebuttom: {String: this.sitebuttom, Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/aaubi',
        method: 'post',
        data: savedata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.siteid = res.data.data
            that.$message({
              type: 'success',
              message: '保存信息成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    cancelsite () {
      that.siteid = -1
      that.sitetitle = ''
      that.sitewelcome = ''
      that.sitekey = ''
      that.sitebuttom = ''
      that.wsimgurlok = false
      that.wsimgurl = ''
      that.upfilepath = ''
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/website/SiteSet.vue